import { Arrow } from './arrow';
import styles from './vertical-arrows.module.css';

const ARROW_LENGTH = 40;
const LABEL_OFFSET = 6;
const LABEL_MAX_WIDTH = 90;

type VerticalArrowsProps = {
  height: number;
  width: number;
  topLabel?: string;
  bottomLabel?: string;
  color?: string;
  fontFamily?: string;
  opacity?: number;
};

/**
 * A pair of up/down arrows with labels, rendered as an overlay on the right
 * side of a DivergingBarChart. All inputs are plain data so it serializes
 * cleanly into a shared-report snapshot.
 */
export const VerticalArrows = ({
  height,
  width,
  topLabel,
  bottomLabel,
  color = '#2d426a',
  fontFamily = 'inherit',
  opacity = 0.7,
}: VerticalArrowsProps) => {
  const arrowCenterX = width / 2;

  const centerY = height * 0.38;
  const offsetFromCenter = Math.min(60, height * 0.18);

  const topArrowY = centerY - offsetFromCenter;
  const bottomArrowY = centerY + offsetFromCenter;

  const topLabelTop = topArrowY + ARROW_LENGTH + LABEL_OFFSET;
  const bottomLabelTop = bottomArrowY + ARROW_LENGTH + LABEL_OFFSET;

  const labelStyle = { color, opacity, fontFamily, maxWidth: LABEL_MAX_WIDTH };

  return (
    <div className={styles.container}>
      <svg className={styles.svg} style={{ height }}>
        <g transform={`translate(${arrowCenterX}, 0)`}>
          <Arrow
            direction="up"
            x={0}
            y={topArrowY}
            length={ARROW_LENGTH}
            color={color}
            opacity={opacity}
          />
        </g>
        <g transform={`translate(${arrowCenterX}, 0)`}>
          <Arrow
            direction="down"
            x={0}
            y={bottomArrowY}
            length={ARROW_LENGTH}
            color={color}
            opacity={opacity}
          />
        </g>
      </svg>
      {topLabel && (
        <div className={styles.labelAnchor} style={{ top: topLabelTop }}>
          <div className={styles.label} style={labelStyle}>
            {topLabel}
          </div>
        </div>
      )}
      {bottomLabel && (
        <div className={styles.labelAnchor} style={{ top: bottomLabelTop }}>
          <div className={styles.label} style={labelStyle}>
            {bottomLabel}
          </div>
        </div>
      )}
    </div>
  );
};
